import type { FieldTypeValue } from '@cli-types/core-engine/schema.js'
import { FIELD_TYPES } from '@cli-constants/schema.js'

export function isFieldType(value: string): value is FieldTypeValue {
  return Object.values(FIELD_TYPES).includes(value as FieldTypeValue)
}
